import { useState, useEffect } from 'react';
import { Tooltip } from '../SearchTooltip';
import { getSupportedChains, SwapChain, SwapScene } from '../api';
import { TokenIcon } from './TokenIcon';
import clx from 'classnames';
import { useLocale } from '../../../store/i18nMessage';

import styles from './index.module.scss';

// 判断是否为空值
export const isNullOrUndefined = (v: unknown) => {
  try {
    return Object.prototype.toString.call(v) === '[object Undefined]' || Object.prototype.toString.call(v) === '[object Null]';
  } catch {
    return false;
  }
};

interface Props {
  chainId: string;
  chains: SwapChain[];
  onChangeChainId: (chainId: string) => void;
}

export const SearchNetwork = (props: Props) => {
  const { chainId, onChangeChainId, chains } = props;
  const { t } = useLocale();

  return (
    <div className={styles.container}>
      <div className={styles.chainBoxTitle}>
        {t('chooseNetwork')}: {chainId === '' ? 'ALL' : chains.find((item) => +item.chainId === +chainId)?.chainName}
      </div>
      <div className={styles.content}>
        <div
          className={clx(styles.chainBoxItem, styles.chainBoxText, {
            [styles.actived]: chainId === '',
          })}
          onClick={() => {
            onChangeChainId('');
          }}
        >
          ALL
        </div>
        {chains?.map((item) => (
          <Tooltip key={item.chainId} content={item?.chainName || '--'}>
            <div
              className={clx(styles.chainBoxItem, {
                [styles.actived]: chainId === item.chainId,
              })}
              onClick={() => {
                onChangeChainId(item.chainId);
              }}
            >
              <TokenIcon tokenSrc={item.iconNightUrl} tokenSize={20} />
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};
